import React from 'react'

export const Print_barcode_page = React.forwardRef((props, ref) => {
  return (
    <div ref={ref}>
        <div className="barcode_show">
            {/* <div className="w-full h-full flex flex-wrap justify-center items-stretch"> */}
            <div className="w-full px-3 flex justify-center text-sm">
                {props?.code}
            </div>
            <div className="w-full flex justify-center text-sm">
                {props?.name}
            </div>
            <div className="w-full flex justify-center ">
                {props?.price} $
            </div>
        </div>
    </div>
  );
});